import React from 'react'
import ReactHtmlParser from 'react-html-parser';


/**
  * @class Popin
  * Show Popin
*/
class Popin extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      showPopin: (this.props.details) ? true : false
    }
    this.handleClick = this.handleClick.bind(this)
  }

  componentWillReceiveProps() {
    this.setState((prevState, props) => {
      return {showPopin: (this.props.details) ? true : false}
    })
  }

  handleClick() {
    this.setState((prevState, props) => {
      return {showPopin: false}
    })
  }

  render() {
    const path = process.env.PUBLIC_URL
    const client = this.props.details
    if(this.state.showPopin === false) return null
    return (
      <div className="overlay">
        <div className="popin container-fluid">
          <div className="row">
            <div className="col-12 col-lg-6 col-xl-5">
              <div className="col-12">
                <button onClick={this.handleClick} className="popin__close">
                  <img className="icon-close" src={"/images/bt-close.png"} alt="X" />
                </button>
              </div>
              <div className="col-12">
                <p><img className="logo" src= { process.env.PUBLIC_URL + "/images/" + client.acf["logo"].split("/").pop() } alt="" /></p>
              </div>
              <div className="col-12">
                <div className="popin__content">
                  <b>Le challenge</b><br/>
                  { ReactHtmlParser(client.acf["challenge"]) }
                  <br/>
                    <b>La réponse</b><br/>
                    { ReactHtmlParser(client.acf["reponse"]) }
                    <br/><br/>
                </div>
                <div className="popin__tags">
                  <p><b>{client.acf["client"]} </b></p>
                  <p>{client.tags}</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6 col-xl-7 nopadding align-self-center">
              <img src= { process.env.PUBLIC_URL + "/images/" + client.picture.split("/").pop() } alt="" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Popin




// WEBPACK FOOTER //
// ./src/components/Popin.jsx